import $ from 'jquery';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import GLightbox from 'glightbox';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Animations, Events, Classes } from './constants';
import { fixMobileHover, sortAnimations, getCookiesAllowed, initGTM, isDisclaimerAccepted, setCookiesAllowed, setDisclaimerAccepted, smoothScrollTo, isTouchScreen, wait } from './helpers';

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- Fix Scroll ----------

history.scrollRestoration = "manual";

// ---------- Touch Screen ----------

if(isTouchScreen()) {
	$Elements.html.addClass('touchscreen');
}

// ---------- jQuery Related ----------

$Elements.document.on(Events.page.enter, async() => {

	// ---------- Fix VH ----------

	$Elements.window.on('resize', () => document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`));
	$Elements.window.trigger('resize');

	// ---------- Fix Mobile Hover ----------

	$Elements.window.on('load', () => fixMobileHover());

	// ---------- Handle Aniamtions ----------

	ScrollTrigger.matchMedia(sortAnimations(Animations));

	// ---------- Announcement Bar Marquee ----------

	const announcementSection = document.querySelector('.announcement-bar-section');

	if (announcementSection) {
		const track = announcementSection.querySelector('.announcement-bar-track');
		const set = track?.querySelector('.announcement-bar-set');

		if (track && set) {
			const setWidth = set.offsetWidth;
			const copies = Math.ceil((window.innerWidth * 2) / setWidth) + 1;

			for (let i = 0; i < copies; i++) {
				track.appendChild(set.cloneNode(true));
			}

			const tween = gsap.to(track, {
				x: -setWidth,
				duration: 20,
				ease: 'none',
				repeat: -1,
			});

			announcementSection.addEventListener('mouseenter', () => tween.pause());
			announcementSection.addEventListener('mouseleave', () => tween.resume());
		}
	}

	// ---------- Links ----------

	$Elements.body.on('click', 'a[href="#"], .void-link', (e) => e.preventDefault());

	$Elements.body.on('click', '[data-scroll-to], [target="scroll-to"]', function(e) {
		e.preventDefault();

		const self = $(this);
		const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

		if(target.length) {
			smoothScrollTo(target);
		}
	});

	$Elements.body.on('click', '.select-dropdown .dropdown-menu .btn', function() {
		$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
	});

	// ---------- GLightbox ----------

	$('[target="lightbox"]').each(function() {

		GLightbox({
			selector: 'a[href="' + this.attributes.href.value + '"][target="lightbox"]',
			openEffect: 'fade',
			closeEffect: 'fade',
			videosWidth: 1280,
		});
	});

	$('[target^="lightbox-gallery"]').each(function() {

		GLightbox({
			selector: 'a[target="' + this.attributes.target.value + '"]',
			openEffect: 'fade',
			closeEffect: 'fade',
			videosWidth: 1280,
		});
	});

	// ---------- Cookies ----------

	initGTM();

	if(!getCookiesAllowed()) {

		const cookies = document.querySelector('#cookies-allowed');

		if(cookies) {

			cookies.classList.remove(Classes.hidden);
			await wait(100);
			cookies.classList.add(Classes.show);

			$(cookies).on('click', '[data-bs-dismiss="alert"]', function() {
				setCookiesAllowed(this.dataset.allowed);
			});
		}
	}

});


// ---------- Disclaimer ----------

if(!isDisclaimerAccepted()) {

	const disclaimer = document.querySelector('#disclaimer');

	if(disclaimer) {

		disclaimer.classList.remove(Classes.hidden);
		$Elements.body.addClass(Classes.disclaimer);

		$(disclaimer).on('close.bs.alert', function() {
			setDisclaimerAccepted();
			$Elements.body.removeClass(Classes.disclaimer);
		});
	}

}
